import { createSelector } from '@reduxjs/toolkit';
import { CpuArchitecturesListState } from 'ducks/cpu-architectures-list/slices';
import { RootState } from 'store';

const cpuArchitecturesListSlice = (state: RootState) => state.cpu_architectures_list;

export const selectCpuArchitecturesList = createSelector(
  [cpuArchitecturesListSlice],
  (state): CpuArchitecturesListState => state,
);
